<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>
		<span class="module_heading" style="white-space: nowrap;">Resources & Updates</span>
		<div class="add_icon_container" @click="addNewNote">
          		<i class="fa fa-plus icon_add" ></i>
      		</div>
		 <div class="sel_fil_wrap one">
            <multiselect
              v-model="selectedType"
              :options="typeList"
              :show-no-results="true"
              ref="multiselect"
              label="name"
              :track-by="id"
              open-direction="bottom"
              :taggable="false"
              placeholder="Select type"
              class="form-control multi-dropdown select_filter"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              @select="selectType"
              @remove="removeType"
            />
          </div>
     
    </template>
  </CommonHeader>
</template>

<script>

import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue"
import Template from '../templates/Template.vue';
export default {
	name: "ReleaseNotesHeader",
	components:{Multiselect, CommonHeader},
	data(){
		return{
			typeList:[
				{
					name:"All",
					id:"all"
				},
				{
					name:"Resource",
					id:"Resource"
				},
				{
					name:"Update",
					id:"Update"
				}
			],
			selectedType:null
		}
	},
	methods:{
		addNewNote(){
			this.$router.push({path:'/addNote'});
		},
		selectType(data){
			if(data.id!='all'){
				this.$emit("getList", data.id)
			}
			else{
				this.$emit("getList")
			}
		},
		removeType(data){
			this.$emit("getList")
		}
	}
}
</script>
